import type { FormField, FormSection } from '@/components/form-builder/types'

// Field types that can't surface in the procedure header — the anchored-category
// auto-anchor rule skips them.
export function anchorEligible(f: FormField): boolean {
  return f.type !== 'section' && f.type !== 'table' && f.type !== 'calculated'
}

/** Forms in the 'anchored' category surface every eligible field in the procedure header. */
export function anchorAllEligibleFields(sections: FormSection[]): FormSection[] {
  return sections.map(s => ({
    ...s,
    fields: s.fields.map(f => (anchorEligible(f) ? { ...f, anchored: true } : f)),
  }))
}
